<template>
    <div id="loginComponent">
        <facebook-account-kit ref="accountKit"
                              :appId="fbAppId"
                              version="v1.0"
                              :fbAppEventsEnabled='true'
                              :debug='true'
                              :loginType='loginType'
                              state="somecrsf">
            <h2 class="loginTitle">Sign in</h2>
            <h3 v-if="loginType === 'PHONE'">Sign in by phone number</h3>
            <h3 v-if="loginType === 'EMAIL'">Sign in by email</h3>
            <div class="listFields">
                <div v-if="loginType === 'PHONE'" class="field phone-field">
                    <i class="fa fa-phone" aria-hidden="true"></i>
                    <input placeholder="Enter your phone number" id="phone_number" v-model="phoneNumber"
                           @keyup.enter="login"/>
                </div>
                <div v-if="loginType === 'EMAIL'" class="field email-field">
                    <i class="fa fa-envelope" aria-hidden="true"></i>
                    <input placeholder="Enter your email address" id="email" v-model="emailAddress"
                           @keyup.enter="login"/>
                </div>
                <button @click="login()">Sign in</button>
            </div>
            <h3 v-if="akEmail || loginFb">Or sign in with</h3>
            <div class="login-btn">
                <div class="field-btn" v-if="loginFb">
                    <login-facebook class="button"
                                    ref="fbRef"
                                    :appId="fbAppId"
                                    loginLabel="FACEBOOK"
                                    @login="loginFacebook"
                                    @logout="onLogout"
                                    @sdk-loaded="sdkLoaded">
                    </login-facebook>
                </div>
                <div class="field-btn" v-if="akEmail">
                    <button @click="changedLogin()">{{loginType === 'EMAIL' ? 'PHONE NUMBER':'EMAIL'}}</button>
                </div>
            </div>
        </facebook-account-kit>
        <!-- modal-->
        <modal v-if="showModal" @close="showModal = true" class="userModal">
            <template slot="header">
                <span v-on:click="showModal = false" class="close"></span>
            </template>
            <template slot="body">
                <h3>Your account information:</h3>
                <form action="" class="form-associate" @submit.prevent="createUser">
                    <div class="form-group">
                        <label for="givenName">Given Name:</label>
                        <input type="text" class="form-control" id="givenName" v-model="customer.givenName">
                    </div>
                    <div class="form-group">
                        <label for="familyName">Family Name:</label>
                        <input type="text" class="form-control" id="familyName" v-model="customer.familyName">
                    </div>
                    <div class="form-group">
                        <label for="mEmail">Email Address:</label>
                        <input type="text" class="form-control" id="mEmail" v-model="customer.email" :disabled="this.loginType == 'EMAIL' ? true : false">
                    </div>
                    <div class="form-group">
                        <label for="mPhone">Phone:</label>
                        <input type="text" class="form-control" id="mPhone" v-model="customer.phone" v-on:change="formatPhone" v-mask="'############'" :disabled="this.loginType == 'PHONE' ? true : false">
                    </div>
                    <p v-if="family">Do you normally visit the Snap Cafe / Thai Street as a family?</p>
                    <div class="form-group flex-column" v-if="family">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="family" id="yFamily" value="1" v-model="customer.family">
                            <label class="form-check-label" for="yFamily">Yes, width children</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="family" id="nFamily" value="0" v-model="customer.family">
                            <label class="form-check-label" for="nFamily">No, without children</label>
                        </div>
                    </div>
                    <p class="feature">Additional information - it&#39;s not mandatory, but by providing it, you will be eligible for
                        additional freebies - like a birthday present! :)</p>
                    <div class="form-group flex-column">
                        <label>Are you:</label>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="gender" id="male" value="1" v-model="customer.sex">
                            <label class="form-check-label" for="male">Male</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="gender" id="female" value="0" v-model="customer.sex">
                            <label class="form-check-label" for="female">Female</label>
                        </div>
                    </div>
                    <!--<div class="form-group">
                        <label>Your Nationality</label>
                        <select v-model="customer.nationality">
                            <option disabled value="">Please select one</option>
                            <option v-for="option in nationalities" v-bind:value="option">
                                {{ option }}
                            </option>
                        </select>
                    </div>-->
                    <div class="form-group">
                        <label :for="idDatePicker">Your date of Birth:</label>
                        <datepicker :id="idDatePicker" v-model="customer.birthday" :format="format" :initialView="'year'"></datepicker>
                    </div>
                    <h3>We want to stay in touch!</h3>
                    <p>By joining our loyalty program we will automatically subscribe you to receive:</p>
                    <ul>
                        <li>A monthly e-newsletter</li>
                        <li>Occasional special offers or announcements sent via a phone messaging service</li>
                    </ul>
                    <p>You can opt out of either of these at any time by following the unsubscribe instructions in the
                        communications themselves.</p>
                    <h3>Our Privacy Commitment</h3>
                    <p>Please note that we do not share any personal data with any third parties.</p>
                    <div class="form-group">
                    <button class="btn btn-update" v-bind:class="{ loading: loading }">Update</button>
                    </div>
                </form>
            </template>
        </modal>
        <!-- modal-->
    </div>
</template>

<script>
    import Modal from './Modal.vue'
    import nationalities from '../nationalities.json';
    export default {
        name: 'Login',
        components: {
            Modal,
        },
        props: ['akEmail', 'loginFb','family'],
        data() {
            return {
                showModal: false,
                loginType: "PHONE",
                emailAddress: "",
                countryCode: "+84",
                phoneNumber: "",
                isConnected: false,
                fbAppId: this.$foodbookConfig.fbAppId,
                akSecret: this.$foodbookConfig.akSecret,
                FB: undefined,
                nationalities:nationalities,
                customer:{
                    birthday: null,
                    phone: null,
                    email:null,
                    givenName: null,
                    familyName: null,
                    family: -1,
                    nationality:"",
                    sex: -1,
                    fbID: '',
                },
                idDatePicker:'mbirthday',
                format:'dd/MM/yyyy',
                loading: false,
            };
        },
        filters: {
            formatDate(date,type=true) {
                if(date){
                    if(type){
                        let d = new Date(date);
                        return ("0" + d.getDate()).slice(-2) + '/' + ("0" + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear();
                    }else{
                        let d = new Date(date.split('/').reverse().join('-'));
                        return d.toJSON();
                    }
                }
                return null;
            },
        },
        created(){

        },
        computed: {
            member: function () {
                return {
                    name: this.customer.familyName + ' , ' + this.customer.givenName,
                    birthday: this.$options.filters.formatDate(this.customer.birthday),
                    phone: this.customer.phone,
                    email: this.customer.email,
                    gender: this.customer.sex,
                }
            }
        },
        methods: {
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            formatPhone(){
                if (!this.customer.phone) return false;
                let firstChar = this.customer.phone.substring(0, 1);
                if (firstChar === '0') {
                    this.customer.phone = '84' + this.customer.phone.substring(1)
                }
            },
            formatNumberPhone($phone) {
                let change = [
                    ["843","8416"],
                    ["8470","84120"],
                    ["8479","84121"],
                    ["8477","84122"],
                    ["8476","84126"],
                    ["8478","84128"],
                    ["8483","84123"],
                    ["8484","84124"],
                    ["8485","84125"],
                    ["8481","84127"],
                    ["8482","84129"],
                    ["8458","84188"],
                    ["8456","84186"],
                    ["8459","84199"]
                ];
                _.forEach(change, function(value) {
                    if($phone.indexOf(value[0]) == 0){
                        $phone = $phone.replace(value[0],value[1]);
                        return false;
                    }
                });
                return $phone;
            },
            //Login with account kit
            login() {
                if (this.loginType === "PHONE") {
                    if (this.phoneNumber.length < 9) {
                        this.$toasted.show("Phone numbers must be more than 10 numbers", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        return;
                    }
                } else if (this.loginType === "EMAIL") {
                    if (!this.emailAddress) {
                        this.$toasted.show("You need to enter your email", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        return;
                    } else if (!this.validEmail(this.emailAddress)) {
                        this.$toasted.show("Your email address is invalid", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        return;
                    }
                }
                this.$refs.accountKit.login(
                    {
                        countryCode: this.countryCode,
                        phoneNumber: this.phoneNumber,
                        emailAddress: this.emailAddress,
                        display: "modal"
                    },
                    this.loginCallback
                );
            },
            //Change login with Email or Phone number
            changedLogin() {
                if (this.loginType === 'PHONE') {
                    this.loginType = 'EMAIL';
                    this.phoneNumber = '';
                } else {
                    this.loginType = 'PHONE';
                    this.emailAddress = '';
                }
            },

            //Call to Wp Site wheen loged
            loginCallback(response) {
                if (response.status === 'PARTIALLY_AUTHENTICATED') {
                    //Check sdt
                    this.$http.get(this.$foodbookConfig.wpapi + '/authorize', {
                        params: {
                            code: response.code,
                        }
                    }).then((responseData) => {
                        // console.log(response);
                        if(responseData.data.error){
                            this.$toasted.show(responseData.data.error, {type: 'error'});
                        }else {
                            let phone = this.phoneNumber; //0###########
                            let email = this.emailAddress;
                            //Add 0
                            let phone0 = responseData.data.phone ? '0' + responseData.data.phone.national_number : '';
                            this.customer.email = responseData.data.email ? responseData.data.email.address : '';
                            if (responseData.data.phone && phone === phone0 || responseData.data.email && email === this.customer.email) {
                                if (responseData.data.phone) {
                                    let phonestr = responseData.data.phone.country_prefix.concat(responseData.data.phone.national_number);
                                    this.customer.phone = this.formatNumberPhone(phonestr);
                                }
                                this.logged();
                            }else {
                                this.$toasted.show('There was a problem when authenticating the account', {type: 'error'})
                            }
                        }
                    }).catch((error) => {
                        this.$toasted.show('Failed to authenticate the account', {type: 'error'})
                    });
                } else {
                    this.$toasted.show('Can not login. Please confirm the OTP code', {
                        duration: 5000,
                        type: 'error'
                    });
                }
            },
            logged() {
                let user_id = this.loginType === "PHONE" ? this.customer.phone : this.customer.email;
                let field = this.loginType === "PHONE" ? 'login' : 'email';
                var promise1 = this.$http.get(this.$foodbookConfig.wpapi + '/userExists', {
                    params: {
                        user_id : user_id,
                        field : field
                    }
                });
                var promise2 = this.$http.get(this.$foodbookConfig.wpapi + '/membership_detail', {
                    params: {
                        user_id: this.customer.phone
                    }
                });
                Promise.all([promise1, promise2]).then(([v1,v2]) => {
                    if(v2.body.data && v2.body.data.phone_number == this.customer.phone){
                        if(!v1.body.user_exits){
                            this.customer.birthday = v2.body.data.birthday;
                            this.customer.email = v2.body.data.email;
                            this.customer.sex = v2.body.data.gender;
                            let names = v2.body.data.name.split(',',2);
                            this.customer.familyName = names[0]?names[0].trim():'';
                            this.customer.givenName = names[1]?names[1].trim():'';
                            this.createUserWP();
                        }else{
                            console.log('Login');
                            this.loginWP(v1.body.user.ID);
                        }
                    }else{
                        this.showModal = true;
                    }
                }).catch(reason => {
                    console.log(reason);
                });
            },

            loginWP($user_id){
                this.$http.post(this.$foodbookConfig.wpapi + '/loginWP', {
                    user_id: $user_id
                }).then(response => {
                    if (response.body.success){
                        window.location.replace(this.$foodbookConfig.profilepage);
                    }else{
                        this.$toasted.show("Failed to authenticate the account", {
                            position: "top-center",
                            duration: 10000,

                            type: 'error'
                        });
                        return;
                    }
                }, response => {
                    console.log('Error');
                });
            },

            //Login with facebook
            loginFacebook() {
                this.isConnected = true;
                this.FB.api('/me', 'GET', {fields: 'id,name,email'},
                    userInformation => {
                        if (userInformation.error) {
                            console.log(userInformation.error);
                        } else {
                            this.$http.post(this.$foodbookConfig.wpapi + '/userFB', {
                                email: userInformation.email,
                                id: userInformation.id
                            }).then(response => {
                                if (response.body.check){
                                    window.location.replace(this.$foodbookConfig.profilepage);
                                } else {
                                    this.showModal = true;
                                    this.customer.email = userInformation.email;
                                    this.customer.name = userInformation.name;
                                    this.customer.fbID = userInformation.id;
                                    this.loginType = "EMAIL";
                                }
                            }, response => {
                                console.log('Error');
                            });
                        }
                    }
                )
            },
            onLogout() {
                this.isConnected = false;
            },
            sdkLoaded(payload) {
                this.isConnected = payload.isConnected;
                this.FB = payload.FB;
                if (this.isConnected) {
                    this.$refs.fbRef.logout();
                }
            },
            createUser() {
                if (!this.customer.givenName) {
                    this.$toasted.show("You need to enter your given name!", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }
                if (!this.customer.familyName) {
                    this.$toasted.show("You need to enter your family name !", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }
                /*if (!this.customer.family) {
                    this.$toasted.show("Do you normally visit the Snap Cafe / Thai Street as a family?", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }*/
                if (!this.validEmail(this.customer.email)) {
                    this.$toasted.show("Your email address is invalid", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }
                if (!this.customer.phone) {
                    this.$toasted.show("You need to enter your phone number", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }
                if (this.customer.phone.length < 10) {
                    this.$toasted.show("Phone number must be more than 10 numbers", {
                        theme: "bubble",
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }
                if (this.customer.phone.substring(0, 2) !== '84') {
                    this.$toasted.show("Phone number is incorrect (84xxxxxxx)", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }
                this.loading = true;
                let user_id = this.loginType === "EMAIL" ? this.customer.phone : this.customer.email;
                let field = this.loginType === "EMAIL" ? 'login' : 'email';
                var promise1 = this.$http.get(this.$foodbookConfig.wpapi + '/userExists', {
                    params: {
                        user_id : user_id,
                        field : field
                    }
                });
                var promise2 = this.$http.get(this.$foodbookConfig.wpapi + '/membership_detail', {
                    params: {
                        user_id: this.customer.phone
                    }
                });
                Promise.all([promise1, promise2]).then(([v1,v2]) => {
                    if(field == 'login'){
                        if(v1.body.user_exits){
                            this.$toasted.show( 'Phone number already in use', {
                                duration: 10000,
                                type: 'error'
                            });
                            this.loading = false;
                            return;
                        }else if(!v1.body.user_exits && v2.body.data && v2.body.data.phone_number == this.customer.phone){
                            this.$toasted.show( 'Phone number already in use . You need to login with phone number', {
                                duration: 10000,
                                type: 'error'
                            });
                            return;
                        }else{
                            this.createUserWP(true);
                        }
                    }else{
                        if(v1.body.user_exits){
                            this.$toasted.show( 'Email address already in use', {
                                duration: 10000,
                                type: 'error'
                            });
                            this.loading = false;
                            return;
                        }else if(!v1.body.user_exits && v2.body.data && v2.body.data.phone_number == this.customer.phone){
                            console.log('update');
                            this.createUserWP();
                        }else{
                            console.log('create');
                            this.createUserWP(true);
                        }
                    }
                }).catch(reason => {
                    console.log(reason);
                });
            },
            createUserWP(foodbook = false ){
                this.$http.post(this.$foodbookConfig.wpapi + '/userAK', this.customer).then(response => {
                    if (response.body.user) {
                        this.customer.phone = response.body.user.data.user_login;
                        if(foodbook){
                            this.createUserFB();
                        }else{
                            window.location.replace(this.$foodbookConfig.profilepage);
                        }
                    }
                }, response => {
                    console.log('Account creation failed, please try again later');
                    this.$toasted.show( 'Account creation failed, please try again later', {
                        duration: 20000,
                        type: 'error'
                    });
                });
            },
            createUserFB() {
                this.$http.post(this.$foodbookConfig.wpapi + '/member', this.member, {method: 'POST'}).then(response => {
                    if (response.body.data === "1") {
                        console.log('Create member');
                        window.location.replace(this.$foodbookConfig.profilepage);
                    } else {
                        console.log(response.body.error);
                    }
                }, response => {
                    console.log('Account creation failed, please try again later');
                    this.$toasted.show( 'Account creation failed, please try again later', {
                        duration: 20000,
                        type: 'error'
                    });
                });
            },
            updateUserFB() {
                this.$http.post(this.$foodbookConfig.wpapi + '/updateMember', this.member, {method: 'POST'}).then(response => {
                    if (response.body.data === "1") {
                        console.log('Update member');
                        window.location.replace(this.$foodbookConfig.profilepage);
                    } else {
                        console.log(response.body.error);
                    }
                }, response => {
                    console.log('Account creation failed, please try again later');
                });
            },
            checkUserFB(phone) {
                this.$http.get(this.$foodbookConfig.wpapi + '/membership_detail', {
                    params: {
                        user_id: phone
                    }
                }).then(response => {
                    if (response.body.error) {
                        this.$toasted.show( 'Failed to authenticate the account', {
                            duration: 20000,
                            type: 'error'
                        });
                    }else{
                        if (response.body.data) {
                            console.log("User already exists");
                            window.location.replace(this.$foodbookConfig.profilepage);
                        }
                    }
                }, response => {
                    console.log("Error");
                });
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/OldLogin.vue